import React, { useEffect } from 'react'
import IdeaPanel from '../../components_newui/idea_panel/View'

export const EvaluationInnovateIdea = (props)=>{
//    console.log("🚀 ~ EvaluationInnovateIdea ~ props:", props)
   
    const  {getEvaluationDashboadInnovateIdeaFn,classes,getEvaluationDashboardIdeaIsLoading,getEvaluationDashboardIdea} = props || {}


if(getEvaluationDashboardIdeaIsLoading){
    return 'loading...'
}
    return(
        <div className={classes.wrp2cols}>
        {
            getEvaluationDashboardIdea?.map((idea)=>{
               return <IdeaPanel key={idea.id} isInnovate={idea?.isInnovate}  urlId={idea.id} idea={idea}/>
            })
        }
        </div>
    )
}

